import { IColumnHeader } from '@aon/aon-tws-common-ui';
import _ from 'lodash';
import { IAttributeVm, IColumn } from '../models';

export const ColumnHelper = {
	GetColumnHeaders(columns: IColumn[]) {
		return _.map(this.GetSelectedColumns(columns), (c: IColumn) => this.GetColumnHeaderFromColumn(c));
	},
	UpdateSortableColumns(columns: IColumnHeader[], sortableColumnNames: string[], sortAscByDefault?: boolean): IColumnHeader[] {
		return _.map(columns, (c: IColumnHeader) => ({
			...c,
			isSortable: sortableColumnNames.indexOf(c.field) > -1,
			sortAscByDefault,
		}));
	},
	GetUpdateColumnHeaders(columns: IColumn[], sortableColumnNames: string[], sortAscByDefault?: boolean): IColumnHeader[] {
		const columnHeaders = this.GetColumnHeaders(columns);
		return this.UpdateSortableColumns(columnHeaders, sortableColumnNames, sortAscByDefault);
	},
	GetColumnHeaderFromColumn(column: IColumn) {
		const columnHeader: IColumnHeader = {
			label: column.displayText,
			field: column.name,
			isSortable: column.isSortable,
			sortAscByDefault: column.sortAscByDefault,
		};
		return columnHeader;
	},

	GetSelectedColumns(columns: IColumn[]) {
		return _.filter(columns, (c: IColumn) => c.checked);
	},

	GetSelectedColumnNames(columns: IColumn[]) {
		const selectedColumns = this.GetSelectedColumns(columns);
		return _.map(selectedColumns, (c: IColumn) => c.name);
	},

	UpdateSelectedColumns(columns: IColumn[], values: string[]) {
		const clonedColumns = _.cloneDeep(columns);
		return _.map(clonedColumns, (c: IColumn) => {
			c.checked = values.indexOf(c.name) > -1;
			return c;
		});
	},
	MapAttributesToColumns(attributes: IAttributeVm[], startingIndex?: number) {
		const masterIndex = startingIndex === undefined ? 0 : startingIndex + 1;
		const attributeColumns: IColumn[] = attributes.map((attribute: IAttributeVm, index: number) => ({
			name: attribute.attributeId.toString(),
			displayText: attribute.csvColumnName,
			checked: false,
			disabled: false,
			displayOrder: masterIndex + index,
		}));

		return attributeColumns;
	},

	GetExtraColumnNames(defaultColumns: IColumn[], columns?: IColumn[]) {
		if (!columns) {
			return [];
		}

		const extraColumnNames = columns
			.filter((c: IColumn) => defaultColumns.find((cl: IColumn) => cl.name === c.name) === undefined && c.checked)
			.map((c: IColumn) => c.name);

		return extraColumnNames;
	},
};
